var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M220.134 0H80C28.9334 0 0 28.9334 0 80V220.001C0 271.066 28.9334 300 80 300H220.134C271.2 300 300 271.066 300 220.001V80C300 28.9334 271.2 0 220.134 0Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1107 118.777C82.4441 118.777 77.7773 123.444 77.7773 129.221V215.11C77.7773 220.778 82.4441 225.444 88.1107 225.444C93.8885 225.444 98.5552 220.778 98.5552 215.11V129.221C98.5552 123.444 93.8885 118.777 88.1107 118.777Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.445 77.7773C140.778 77.7773 136.111 82.444 136.111 88.2217V215.11C136.111 220.778 140.778 225.444 146.445 225.444C152.223 225.444 156.889 220.778 156.889 215.11V88.2217C156.889 82.444 152.223 77.7773 146.445 77.7773Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M203.998 164.109C198.221 164.109 193.555 168.777 193.555 174.554V215.109C193.555 220.777 198.221 225.443 203.887 225.443C209.665 225.443 214.332 220.777 214.332 215.109V174.554C214.332 168.777 209.665 164.109 203.998 164.109Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.c21dca523ec8e6114ecdd77eac88adba.svg";
export { ForwardRef as ReactComponent };